import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';
import SettingWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';
import Settings from './edit/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-saml-providers'),
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_SAML_IDP,
        permissions: ['administrator'],
      },
      component: SettingWrapper,
      children: [
        {
          path: '',
          name: 'wgpt_saml_providers',
          redirect: 'list',
          meta: {
            featureFlag: FEATURE_FLAGS.WGPT_SAML_IDP,
            permissions: ['administrator'],
          },
        },
        {
          path: 'list',
          name: 'wgpt_saml_providers_list',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.WGPT_SAML_IDP,
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-saml-providers'),
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_SAML_IDP,
        permissions: ['administrator'],
      },
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'WGPT_SAML.PROVIDERS.EDIT.HEADER',
          showBackButton: true,
        };
      },
      children: [
        {
          path: ':samlProviderId',
          name: 'wgpt_saml_providers_edit',
          component: Settings,
          meta: {
            featureFlag: FEATURE_FLAGS.WGPT_SAML_IDP,
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
